import Toastify from 'toastify-js';

export default class Notifications {
  static success(message) {
    Toastify({
      text: message,
      duration: 2000,
      close: true,
      gravity: "top", // `top` or `bottom`
      position: "right", // `left`, `center` or `right`
      stopOnFocus: true, // Prevents dismissing of toast on hover
      className: "success",
    }).showToast();
  }

  static alert(message) {
    Toastify({
      text: message,
      duration: 2000,
      close: true,
      gravity: "top", // `top` or `bottom`
      position: "right", // `left`, `center` or `right`
      stopOnFocus: true, // Prevents dismissing of toast on hover
      className: "error",
    }).showToast();
  }
}
